import { Injectable } from '@angular/core';
import { CompanyName } from '@shared/constants/constants';
// import { environment } from '../../../environments/environment';
declare let $: any;

@Injectable()
export class SettingsService {

    public user: any;
    public app: any;
    public layout: any;
    // public version: string = environment.version;

    constructor() {

        // User Settings
        // -----------------------------------
        this.user = {
            name: 'Poweruser',
            company: CompanyName,
            job: 'Admin',
            picture: 'assets/img/user.png'
        };

        // App Settings
        // -----------------------------------
        this.app = {
            name: CompanyName,
            description: 'Event management',
            version: '1.0.0',
            year: '2018'
        };

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

    }

    public getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    public getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    public getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    public setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    public setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }
    public setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }

    public toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

}
